import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/utils/ScrollToTop';

// Pages
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import CustomOrder from './pages/CustomOrder';
import Admin from './pages/Admin';
import TestCheckout from './pages/TestCheckout';
import Showroom from './pages/Showroom';
import Shipping from './pages/Shipping';
import FAQ from './pages/FAQ';

// Checkout Pages
import CheckoutConfirmation from './pages/CheckoutConfirmation';
import ShippingAddress from './pages/ShippingAddress';
import ShippingOptions from './pages/ShippingOptions';
import Payment from './pages/Payment';
import OrderComplete from './pages/OrderComplete';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutFailed from './pages/CheckoutFailed';
import CheckoutQR from './pages/CheckoutQR';
import CheckoutPaymentInstructions from './pages/CheckoutPaymentInstructions';

// Context
import { CheckoutProvider } from './context/CheckoutContext';

// CSS
import './index.css';

function App() {
  return (
    <CheckoutProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/custom" element={<CustomOrder />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/test-checkout" element={<TestCheckout />} />
          <Route path="/showroom" element={<Showroom />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/faq" element={<FAQ />} />
          
          {/* Checkout Routes */}
          <Route path="/checkout/confirmation" element={<CheckoutConfirmation />} />
          <Route path="/checkout/shipping" element={<ShippingAddress />} />
          <Route path="/checkout/shipping-options" element={<ShippingOptions />} />
          <Route path="/checkout/payment" element={<Payment />} />
          <Route path="/checkout/complete" element={<OrderComplete />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/failed" element={<CheckoutFailed />} />
          <Route path="/checkout/qr" element={<CheckoutQR />} />
          <Route path="/checkout/payment-instructions" element={<CheckoutPaymentInstructions />} />
        </Routes>
      </Router>
    </CheckoutProvider>
  );
}

export default App;
